import React, { useEffect } from "react";
import Header from "../components/Header.jsx";
import ClientLogo from "../images/client_logo.svg";
import IntroductionCover from "../images/pocket-guides/introduction-to-biofield-therapies-cover.png";
import PainCover from "../images/pocket-guides/biofield-therapies-for-pain-cover.png";
import CancerCover from "../images/pocket-guides/biofield-therapies-for-cancer-symptoms-cover.png";
import MentalHealthCover from "../images/pocket-guides/biofield-therapies-for-mental-health-and-wellbeing-cover.png";

const guides = [
	{
		title: "Introduction to Biofield Therapies",
		subtitle: "Best Evidence from Clinical Research",
		file: "/static/pocket-guides-assets/introduction-to-biofield-therapies.pdf",
		cover: IntroductionCover,
	},
	{
		title: "Biofield Therapies for Pain",
		subtitle: "What the Clinical Evidence Shows",
		file: "/static/pocket-guides-assets/biofield-therapies-for-pain.pdf",
		cover: PainCover,
	},
	{
		title: "Biofield Therapies for Cancer Symptoms",
		subtitle: "What the Clinical Evidence Shows",
		file: "/static/pocket-guides-assets/biofield-therapies-for-cancer-symptoms.pdf",
		cover: CancerCover,
	},
	{
		title: "Biofield Therapies for Mental Health & Wellbeing",
		subtitle: "What the Clinical Evidence Shows",
		file: "/static/pocket-guides-assets/biofield-therapies-for-mental-health-and-wellbeing.pdf",
		cover: MentalHealthCover,
	},
];

function PocketGuides() {
	useEffect(() => {
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;
	}, []);
	return (
		<>
			<Header />
			<div className="container" id="methods">
				<div className="row">
					<div className="col-12">
						<div className="methods-text-container">
							<div className="methods-text-subcontainer">
								<p
									style={{
										fontWeight: "bold",
										fontSize: "28px",
									}}
								>
									Biofield Science Pocket Guides
								</p>
								<p style={{ fontStyle: "italic" }}>
									Exploring the current landscape on energy
									healing, distilled into short, readable
									guides
								</p>
								Biofield therapies, including Reiki, Healing
								Touch, and Therapeutic Touch, have been
								practiced for centuries to support and enhance
								well-being. To understand their clinical
								effects, the Subtle Energy Funders Collective
								reviewed 418 clinical trials, and these Pocket
								Guides distill that work into plain-language
								insights on general health, pain, and cancer
								symptoms.
								<br />
								<br />
								Over half of the trials reported promising
								evidence, with studies pointing to reduced
								pain, anxiety, stress, and fatigue. The
								research is still early, but the findings
								point in an encouraging direction and show
								where these therapies seem to help most.
								<br />
								<br />
								<p
									style={{
										fontWeight: "bold",
										fontSize: "22px",
									}}
								>
									Explore the Pocket Guides
								</p>
								<div className="row">
									{guides.map((guide) => (
										<div
											className="col-12 col-sm-6 col-md-3 mb-4"
											key={guide.file}
										>
											<div
												style={{
													display: "flex",
													flexDirection: "column",
													alignItems: "center",
												}}
											>
												<img
													src={guide.cover}
													alt={guide.title}
													className="img-fluid"
													style={{
														border: "1px solid #000000",
														marginBottom: 8,
														maxWidth: "85.5%",
													}}
												/>
												<a
													className="btn btn-primary"
													style={{
														width: "140px",
														height: "20px",
														padding: 0,
														display: "flex",
														alignItems: "center",
														justifyContent: "center",
														fontSize: "14px",
													}}
													href={guide.file}
													target="_blank"
													rel="noopener noreferrer"
													download
												>
													Download PDF
												</a>
											</div>
										</div>
									))}
								</div>
							</div>
						</div>

						<div
							style={{
								display: "flex",
								width: "100%",
								justifyContent: "space-between",
								alignItems: "flex-start",
								marginTop: 25,
							}}
						>
							<a
								href="/"
								className="btn btn-primary col-12 col-sm-12 col-md-4"
								id="back_to_map_button"
							>
								Back
							</a>
							<div
								className="bottom-client-logo-container"
								style={{
									display: "flex",
									flexDirection: "column",
								}}
							>
								<p className="upload-excel-container logo-description">
									The Biofield Science Evidence Map was made
									possible <br id="description-break" />
									through funding support from members of:
								</p>{" "}
								<a
									href="https://www.funderscollective.org"
									style={{
										display: "flex",
										width: "200px",
										height: "60px",
									}}
								>
									<img
										id="client_logo"
										src={ClientLogo}
										alt="ClientLogo"
										className="img-fluid"
									/>
								</a>
								<p className="upload-excel-container logo-description">
									<a
										href="https://www.funderscollective.org"
										style={{ display: "block" }}
										target="_blank"
										rel="noopener noreferrer"
									>
										www.funderscollective.org
									</a>
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default PocketGuides;
